module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.isTowerCo() && this.isManager() && this.canAccess('project|maintenance|finance')) ? _c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1920fe2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/EquipControls.vue
// module id = 1347
// module chunks = 0